import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// Using standard styling matching the provided image and likely other reports in the system
// Blue header/footer: #1e429f (similar to Namuna 9)
// Green button: #10b981

const PanipuravthaNamuna1Report = () => {
    const navigate = useNavigate();
    const [fromDate, setFromDate] = useState('2025-04-01');
    const [toDate, setToDate] = useState('2026-03-31');

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center font-poppins p-4">
            <div className="w-full max-w-lg bg-white rounded-lg shadow-xl overflow-hidden border border-gray-200">
                
                {/* Header */}
                <div className="bg-[#267c77] text-white p-4">
                    <h2 className="text-xl font-bold">नमुना १</h2>
                </div>

                {/* Body */}
                <div className="p-8 space-y-6">
                    {/* From Date */}
                    <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                        <label className="text-gray-700 font-medium text-lg md:w-1/3">दिनांका पासुन</label>
                        <div className="relative w-full md:w-2/3">
                            <input 
                                type="date" 
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                className="w-full p-2 pr-10 border border-gray-300 rounded bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#267c77]"
                            />
                        </div>
                    </div>

                    {/* To Date */}
                    <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                        <label className="text-gray-700 font-medium text-lg md:w-1/3">दिनांका पर्यंत</label>
                        <div className="relative w-full md:w-2/3">
                            <input 
                                type="date" 
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                                className="w-full p-2 pr-10 border border-gray-300 rounded bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#267c77]"
                            />
                        </div>
                    </div>
                </div>

                {/* Footer / Button Area */}
                <div className="bg-[#267c77] p-4 flex justify-center">
                    <button 
                        className="bg-[#10b981] hover:bg-[#059669] text-white px-8 py-2 rounded font-bold text-lg shadow-md transition-colors"
                        onClick={() => {
                            navigate('/panipuravtha/financial-report/namuna-1/print', {
                                state: { fromDate, toDate }
                            });
                        }}
                    >
                        नमुना १
                    </button>
                </div>

            </div>
        </div>
    );
};

export default PanipuravthaNamuna1Report;
